<template>
  <div class="purchases-toolbar">
    <div>
      <button class="collapse-lots-button" @click="toggleCollapseRequest">
        <p>{{ collapseButtonLabel }}</p>
        <CollapseIcon class="icon" :class="{ collapsed: isCollapsed }" />
      </button>
    </div>
    <div class="setting-lots">
      <TagLotsButton :disabled="disabled" @toggle-tag="toggleTag" />
      <button
        :disabled="disabled"
        @click="handleHideRestore"
        class="tool-lots"
        :class="{ 'disabled-button': disabled || !isSubscribedUser }"
        :title="
          !isSubscribedUser ? 'Доступно при наличии платной подписки' : ''
        "
      >
        <template v-if="isHiddenTab">
          <img src="../../assets/img/ico-eye-open.svg" alt="hide lots" />
        </template>
        <template v-else>
          <img src="../../assets/img/hide-lots.svg" alt="hide lots" />
        </template>
        <span>
          {{ isHiddenTab ? "Восстановить" : "Скрыть" }}
        </span>
      </button>
      <button
        class="tool-lots bitrix-button"
        :disabled="disabled"
        :class="{ 'disabled-button': disabled || !isSubscribedUser }"
        @click="exportToBitrix"
      >
        <img src="../../assets/img/send-bitrix.svg" alt="send bitrix" />
        <span>Отправить в Bitrix24</span>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TagLotsButton from "../tags/TagLotsButton.vue";
import CollapseIcon from "@/assets/icons/table-collapse.svg";
import { showSubscriptionToast } from "@/services/subscriptionNotification";

export default {
  name: "PurchasesToolbar",
  components: { TagLotsButton, CollapseIcon },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    currentTab: {
      type: Object,
      default: () => ({ filterType: "" }),
    },
    isCollapsed: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapGetters("auth", ["authorities", "email"]),
    ...mapGetters("profile", ["profileId"]),
    ...mapGetters("subscriptions", ["subscriptions"]),
    isSubscribedUser() {
      return this.authorities.includes("ROLE_SUBSCRIBED_USER");
    },
    isHiddenTab() {
      return this.currentTab?.filterType === "HIDDEN";
    },
    isFavoritesTab() {
      return this.currentTab?.filterType === "FAVORITES";
    },
    collapseButtonLabel() {
      return this.isCollapsed ? "Развернуть лоты" : "Свернуть лоты";
    },
  },

  methods: {
    ...mapActions("subscriptions", ["getSubscriptions"]),
    hideItems() {
      this.$emit("hide-items");
    },
    toggleTag(action, tagId) {
      this.$emit("toggle-tag", action, tagId);
    },
    async exportToBitrix() {
      if (this.isSubscribedUser) {
        this.$emit("export-to-bitrix");
        return;
      }

      await this.getSubscriptions(this.profileId);
      showSubscriptionToast(this.subscriptions, this.$toast);
    },
    async handleHideRestore() {
      if (this.isSubscribedUser) {
        if (this.isHiddenTab) this.$emit("restore-items");
        else this.$emit("hide-items");
        return;
      }

      await this.getSubscriptions(this.profileId);
      showSubscriptionToast(this.subscriptions, this.$toast);
    },
    toggleCollapseRequest() {
      this.$emit("toggle-collapse-request");
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/less/variables.less";
@import "../../assets/less/commonStyles.less";

.purchases-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  justify-content: space-between;
  gap: 12px;
  user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
}

.collapse-lots-button {
  height: 48px;
  padding: 0 16px;
  display: flex;
  gap: 12px;
  align-items: center;
  justify-content: center;
  color: #7d919b;

  &:hover {
    background-color: fade(@bg-color-light, 50%);
  }
  .icon {
    transition: all 0.3s ease;
  }
  .collapsed {
    transform: rotate(180deg);
  }
}

.switch-lots {
  display: flex;

  width: 175px;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  padding: 10px;
  transition: @trans;
  cursor: pointer;

  &:hover {
    background-color: fade(@bg-color-light, 50%);
  }

  button {
    color: #79919c;
  }
}

.setting-lots {
  display: flex;
  height: 48px;
  align-items: center;
  cursor: pointer;

  .tool-lots {
    display: flex;
    height: 48px;
    gap: 5px;
    justify-content: center;
    align-items: center;
    padding: 10px;
    transition: @trans;

    &:hover:not(.disabled-button) {
      background-color: fade(@bg-color-light, 50%);
    }

    .marker-favorites {
      width: 8px;
      height: 16px;
      max-height: 40px;
      background-color: #fedd4d;
      border-radius: 1px;
    }

    img {
      width: 20px;
      height: 20px;
    }
  }

  button:disabled {
    opacity: 0.5;
  }
  .disabled-button {
    opacity: 0.5;
    cursor: auto;
  }

  button {
    color: #79919c;
  }

  .bitrix-button {
    width: 183px;
  }
}

el-popper {
  margin-bottom: 0 !important;
}
</style>
